import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RulesDocumentTeacherType } from '../../../types/Teacher';

const initialState:RulesDocumentTeacherType = {
    description: ''
}

const teacherRequiredDocumentSlice = createSlice({
  name: "teacherRequiredDocumentForm",
  initialState,
  reducers: {
        setUpdateTeacherRequiredDocumentData: (
            state: any, action: PayloadAction<RulesDocumentTeacherType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateTeacherRequiredDocumentData: (
            state: any,
        ) => {
            return initialState
        }
  }
});

export const {setUpdateTeacherRequiredDocumentData,resetUpdateTeacherRequiredDocumentData } = teacherRequiredDocumentSlice.actions

export default teacherRequiredDocumentSlice.reducer